import React, { Component } from 'react';
import * as actions from '../../../../../redux/actions/index';
import { connect } from 'react-redux';
import { animateScroll as scroll } from 'react-scroll'
import { convertDateFormatV4, convertDateToDifferentTZ, convertTo24HourFormat, getUser } from '../../../../../utility/utility';
import errorHandler from '../../../../../utility/errorHandler/errorHandler';
import OverrideAvailability from '../../../../component/TimeTrackerModuleComponent/AvailabilityComponent/OverrideAvailability/overrideAvailability';
import moment from 'moment';
import { tzUTCDateTimeConverterTool_V1, tzUTCTCustomDateAndTimeConverterTool, tzUTCTimeConverterTool_V1, tzUTCTimeToActualTime, tzUTCTimeToEslotsActualTime } from '../../../../../utility/TimezoneOperations/timezoneUtility';
import ErrorAlert from '../../../../../utility/errorHandler/errorAlert';
import { TimeTrackerModTypes } from '../../../../../redux/actions/TimeTrackerModAction/TimeTrackerModTypes';
import { platform } from 'chart.js';
const cloneDeep = require('clone-deep');

class OverrideAvailabilityContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
        console.log("PROPSSS", this.props);
        
    }

    componentWillUnmount() {
        this.props.resetState([])
        }

    onCancelClicked = () => {
        this.props.history.goBack();
    }


    // Convert 12-hour time format to 24-hour format
    convertTo24HourFormats = (time12h) => {
      const [time, modifier] = time12h.split(' ');
      let [hours, minutes] = time.split(':');

      if (hours === '12') {
        hours = modifier === 'AM' ? '00' : '12'; 
      } else if (modifier === 'PM' && hours !== '12') {
        hours = parseInt(hours, 10) + 12; 
      }

      return `${hours}:${minutes}`;
    };

    // Convert time string to minutes for easier comparison
    timeToMinutes = (timeStr) => {
      const [hours, minutes] = this.convertTo24HourFormats(timeStr).split(':').map(Number);
      return hours * 60 + minutes;
    };

    // Check if two shifts overlap
    doShiftsOverlap = (shift1, shift2) => {debugger
      let start1 = shift1.start_time;
      let end1 = shift1.end_time;
      let start2 = shift2.start_time;
      let end2 = shift2.end_time;

      if (end1 <= start1) {
        end1 += 24 * 60; // Add 24 hours to end1
      }
      
      if (end2 <= start2) {
        end2 += 24 * 60; // Add 24 hours to end2
      }

      if(shift2?.end_time < shift2.start_time)
      {
        return {
          isValid: false,
          errorMessage: "End time cannot be less than start time"
        }
      }

      if(shift1?.end_time < shift1.start_time)
        {
          return {
            isValid: false,
            errorMessage: "End time cannot be less than start time"
          }
        }

      
      if (start1 === end1 || start2 === end2) {
        return {
          isValid: false,
          errorMessage: "Start time and end time cannot be the same"
        };
      }
      const isOverlap = start1 < end2 && start2 < end1;

      return { 
        isValid: !isOverlap, 
        errorMessage: isOverlap ? "Time slots are overlapping" : null 
      };
    };

    addValidationsSlots = (values, existingSlots, isFullUpdate) => {
      for (let newSlot of values) {
        const { start, end, availability: { value } } = newSlot;
        const newStart = this.timeToMinutes(start);
        const newEnd = this.timeToMinutes(end);

        let adjustedNewEnd = newEnd;
        if (newEnd <= newStart) {
          adjustedNewEnd = newEnd + 24 * 60; 
        }

        if (newStart === newEnd) {
          return { 
            isValid: false, 
            errorMessage: "Start time and end time cannot be the same" 
          };
        }
        
        // For overnight shifts, we already adjusted the end time above
        // So we don't need an additional check here to see if end time comes after start time

        if (!isFullUpdate) {
          for (let existingSlot of existingSlots) {
            const { id, start: existingStart, end: existingEnd } = existingSlot;
            
            if (id === value) continue; // Skip checking against itself

            const existingStartTime = this.timeToMinutes(moment(existingStart).format("hh:mm A"));
            const existingEndTime = this.timeToMinutes(moment(existingEnd).format("hh:mm A"));

            const overlapResult = this.doShiftsOverlap(
              { start_time: newStart, end_time: newEnd },
              { start_time: existingStartTime, end_time: existingEndTime }
            );
            
            if (!overlapResult.isValid) {
              return { 
                isValid: false, 
                errorMessage: "Selected start time and end time is overlapping with existing time" 
              };
            }
          }
        } else {
          // isFull update true means 
          // not check for existing slots
          // check for new slots
          // check for time conflicts
          const newSlots = values.slots || values;

          for (let i = 0; i < newSlots.length; i++) {
            const slotA = newSlots[i];
            const startA = this.timeToMinutes(slotA.start);
            const endA = this.timeToMinutes(slotA.end);
            
            let adjustedEndA = endA;
            if (endA <= startA) {
              adjustedEndA = endA + 24 * 60;
            }
          
            if (adjustedEndA - startA > 24 * 60) {
              return { 
                isValid: false, 
                errorMessage: "A time slot cannot exceed 24 hours" 
              };
            }
          
            for (let j = i + 1; j < newSlots.length; j++) {
              const slotB = newSlots[j];
              const startB = this.timeToMinutes(slotB.start);
              const endB = this.timeToMinutes(slotB.end);
          
              const overlapResult = this.doShiftsOverlap(
                { start_time: startA, end_time: endA },
                { start_time: startB, end_time: endB }
              );
              
              if (!overlapResult.isValid) {
                return { 
                  isValid: overlapResult.isValid, 
                  errorMessage: overlapResult.errorMessage 
                };
              }
            }
          }
        }
      }

      return { isValid: true, errorMessage: null };
    };

    addNewUser = (values) => {
        if(values.data.type === 'true')
        {

            let value = cloneDeep(values);
            value.data.user_id = this.props.match.params?.userId
    
            // if (value.data.start_time == value.data.end_time) {
            //     errorHandler("Start Time and End Time can't be identical");
            //     return false;
            // }  
    
            if (value.data.start_date) {
                value.data.start_date = tzUTCDateTimeConverterTool_V1(value.data.start_date, '00:00:00', 'from');
            }
    
            if (values && values.data && values.data.start_time && values.data.end_time) {
                if (values.data.start_time.includes('PM') && values.data.end_time.includes('AM')) {
                    errorHandler('Select a time range that falls within a single day');
                    return false;
                }
            }
    
            if (value.data.start) {
                value.data.start = tzUTCTCustomDateAndTimeConverterTool(
                    convertDateFormatV4(value.data.start_date), 
                    convertTo24HourFormat(value.data.start));
            }
            
            if (value.data.end) {
                // value.data.end_time = tzUTCTimeConverterTool_V1(convertDateFormatV4(value.data.start_date), convertTo24HourFormat(value.data.end_time));
                value.data.end = tzUTCTCustomDateAndTimeConverterTool(
                    convertDateFormatV4(value.data.start_date), 
                    convertTo24HourFormat(value.data.end));
                
            }

            if(value.data.type)
            {
                value.data.type = value.data.type === 'true' ? "fullday" : "slot";
            }

            
            const payload = {
                
                data: {
                    start_date: value.data.start_date,      
                    type: value.data.type,                         
                    start_time: value.data.start,      
                    end_time: value.data.end,        
                    user_id: value.data.user_id,
                    platform: "web"                         
                }
                
            }
            this.props.overrideAvailability(payload);
        }else{
            //values not available return false
            if(!values)
            {
                return false;
            }
            // check if all the start and end filled or not 
            let isFullUpdate = false;

            values.data.slots.forEach(item => {
                if (item.start && item.end) {
                    isFullUpdate = true;
                }else{
                    isFullUpdate = false;
                }
            });
            
            
            const validationResult = this.addValidationsSlots(
                values.data.slots,
                this.props?.FLShiftDetailBasedAvalibality?.[0]?.slots,
                isFullUpdate
              );
              
              if (!validationResult.isValid) {
                ErrorAlert(validationResult.errorMessage);
                return false;
              }else{
                let value = cloneDeep(values);

                const payload = {
                    data: {
                        start_date: tzUTCDateTimeConverterTool_V1(value.data.start_date, '00:00:00', 'from'),
                        type: value?.data?.type === 'true' ? "fullday" : "slot",
                        user_id: this.props.match.params?.userId,
                        availability_slots: values?.data?.slots?.map((slot, index) => {
                            const slotId = slot?.availability?.value;
                            const startTime = tzUTCTCustomDateAndTimeConverterTool(
                                convertDateFormatV4(value.data.start_date), 
                                convertTo24HourFormat(slot.start)
                            );
                            const endTime = tzUTCTCustomDateAndTimeConverterTool(
                                convertDateFormatV4(value.data.start_date), 
                                convertTo24HourFormat(slot.end)
                            );
                
                            // Check if both start_time and end_time are valid
                            if (startTime !== "Invalid date" && endTime !== "Invalid date") {
                                return {
                                    slot_id: slotId,
                                    start_time: startTime,
                                    end_time: endTime
                                };
                            }
                            return null; // Return null if any time is invalid
                        }).filter(slot => slot !== null) ,// Remove null values from the array
                        platform: "web"
                    }
                };
                this.props.overrideAvailability(payload); 
            }           
        }

    }

    componentDidMount() {
        scroll.scrollToTop();
    }

    componentWillUnmount() {
        this.props.resetObjects();
    }


    render() {

        return (
            <>
                <OverrideAvailability
                    {...this.props}
                    onSubmit={this.addNewUser}
                    onCancelClicked={this.onCancelClicked}
                    isLoading={this.props.isLoading}
                    frontlineUser={this.props.frontlineUser}
                />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.TimeTrackerModReducer.isLoading,
        frontlineUser: state.adminOrSuperAdminReducer.frontlineUser,
        FLShiftDetailBasedAvalibality: state.TimeTrackerModReducer.FLShiftDetailBasedAvalibality,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetObjects: () => dispatch(actions.resetObjects()),
        overrideAvailability: (body) => dispatch(actions.overrideAvailability(body)),
        getShiftDetailForSingleFLUser: (id) => dispatch(actions.getShiftDetailForSingleFLUser(id)),     
        getFrontline: (id) => dispatch(actions.getFrontline(id)),
        resetState: (payload) => dispatch({
                    type: TimeTrackerModTypes.GET_SHIFT_DETAIL_AVALABLITY_FLUSER_FULFILLED,
                    payload
                })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OverrideAvailabilityContainer);